import { render } from "./HowToReportSection.vue?vue&type=template&id=39ad1378&scoped=true"
import script from "./HowToReportSection.vue?vue&type=script&lang=js"
export * from "./HowToReportSection.vue?vue&type=script&lang=js"

import "./HowToReportSection.vue?vue&type=style&index=0&id=39ad1378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ad1378"]])

export default __exports__